import { track } from "@amplitude/analytics-browser";
import {
  Button,
  Card,
  CardContent,
  Grid,
  List,
  ListItem,
  SvgIcon,
  Typography,
} from "@material-ui/core";
import { useSelector } from "react-redux";
import Growth from "../../../assets/images/dashboard/Growth.svg";
import { ReactComponent as PathIcon } from "../../../assets/images/dashboard/Path.svg";
import {
  AmplitudeEventType,
  type AmplitudeTrack,
} from "../../../models/amplitude";
import { type RootState } from "../../../store";
import { useStyles } from "./Banner.styles";

type Selector = {
  profile: RootState["profile"];
};

type Props = {
  onClick: () => void;
};

export const Banner = ({ onClick }: Props) => {
  const classes = useStyles();
  const { profile } = useSelector<RootState, Selector>((state) => ({
    profile: state.profile,
  }));

  if (profile.isPremium) return null;

  const handleButtonClick = () => {
    const amplitudeEvent: AmplitudeTrack<AmplitudeEventType.PREMIUM_PROMOTION_CLICKED> =
      {
        event_type: AmplitudeEventType.PREMIUM_PROMOTION_CLICKED,
        user_id: profile.participantProfileId,
        event_properties: {
          page_url: window.location.href,
        },
      };
    track(amplitudeEvent);
    onClick?.();
  };

  return (
    <Card
      className={classes.card}
      elevation={0}
      data-testid="upgrade-premium-banner"
    >
      <CardContent>
        <Grid container>
          <Grid item lg={12} md={12} sm={12} className={classes.cardContainer}>
            <img className={classes.image} src={Growth} alt="Growth" />
            <Typography className={classes.title}>
              Looking to take your financial wellness to the next level?
            </Typography>
            <List className={classes.list}>
              <ListItem>
                <SvgIcon component={PathIcon} />
                <Typography>Consolidate your Financial Accounts</Typography>
              </ListItem>
              <ListItem>
                <SvgIcon component={PathIcon} />
                <Typography className={classes.accent}>
                  Meet with&nbsp;
                  <Typography component="span">&nbsp;LIVE</Typography>
                  &nbsp;Mentors
                </Typography>
              </ListItem>
              <ListItem>
                <SvgIcon component={PathIcon} />
                <Typography>Learn without limits</Typography>
              </ListItem>
            </List>
            <Button
              className={classes.button}
              onClick={handleButtonClick}
              data-testid="become-premium"
            >
              Try premium for free!
              <SvgIcon component={PathIcon} />
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
